function setAppHeight() {
  document.documentElement.setAttribute( 'style', `--app-height: ${window.innerHeight}px` );
}

function init() {
  setAppHeight();
}

export default {
  init,
};
